export const TYPE_BLUE = 'TYPE_BLUE';
export const TYPE_PURPLE = 'TYPE_PURPLE';
export const TYPE_GREEN = 'TYPE_GREEN';
export const TYPE_RED = 'TYPE_RED';
export const TYPE_ORANGE = 'TYPE_ORANGE';
export const TYPE_DISABLE = 'TYPE_DISABLE';
